// Application Designer — the shared editor shell every designable native page
// mounts. A page may pass its own id map to the shell (Patient Summary keeps the
// `patient-summary-design-*` ids its Design View shipped with); these are the
// defaults a page inherits when it does not.
export const AD = {
  toggle: "application-designer-toggle",
  banner: "application-designer-banner",
  save: "application-designer-save",
  cancel: "application-designer-cancel",
  reset: "application-designer-reset",
  undo: "application-designer-undo",
  redo: "application-designer-redo",
  hidden: "application-designer-hidden",
  restore: "application-designer-restore",
  hide: "application-designer-hide",
  moveUp: "application-designer-move-up",
  moveDown: "application-designer-move-down",
  moveLeft: "application-designer-move-left",
  moveRight: "application-designer-move-right",
  column: "application-designer-column",
  item: "application-designer-item",
  select: "application-designer-select",
  properties: "application-designer-properties",
  propertiesEmpty: "application-designer-properties-empty",
  property: "application-designer-property",
  propertyClear: "application-designer-property-clear",
};
